import { useEffect } from "react";
import { Link } from "react-router-dom";
import { products } from "../data/products";
import { getCategoryBySlug, CategorySlug } from "../data/categories";
import ProductGrid from "components/ProductGrid";
import SEOMeta from "components/SEOMeta";
import CategorySEO from "components/CategorySEO";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";

type CategoryProductsProps = { categorySlug: CategorySlug };

export default function CategoryProducts({ categorySlug }: CategoryProductsProps) {
  const category = getCategoryBySlug(categorySlug);
  const { setItems } = useBreadcrumb();

  useEffect(() => {
    if (!category) return;
    setItems([
      { label: "Accueil", href: "/" },
      { label: "Produits", href: "/produits" },
      { label: category.categoryName },
    ]);
  }, [category, setItems]);

  if (!category) {
    return (
      <div>
        Catégorie introuvable. <Link to="/produits">Retour aux produits</Link>
      </div>
    );
  }

  const categoryProducts = products.filter(
    (p) => p.categorySlug === category.slug
  );
  const paragraphs = category.longDescription.split("\n\n");

  return (
    <>
      <SEOMeta
        title={category.title}
        description={category.description}
        canonicalPath={category.canonicalPath}
      />
      <CategorySEO
        products={categoryProducts}
        canonicalPath={category.canonicalPath}
        categoryName={category.categoryName}
        description={category.description}
      />
      <h1>{category.categoryName}</h1>
      <ProductGrid products={categoryProducts} />
      <section className="category-editorial" style={{ marginTop: 32 }}>
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
        <p>
          {category.linkIntro}
          <a href={category.partnerUrl} target="_blank" rel="noreferrer noopener">
            {category.linkText}
          </a>
          {category.linkOutro}
        </p>
      </section>
    </>
  );
}
